export enum RoomType {
  REGULAR = 'REGULAR',
  CONFERENCE = 'CONFERENCE'
}
